"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LOGOUT_ERROR = exports.NOT_AUTHORIZED = exports.NO_PROVIDER = exports.NO_NONCE = exports.NO_STATE = exports.NO_TOKEN = void 0;
exports.NO_TOKEN = 'NO_TOKEN';
exports.NO_STATE = 'NO_STATE';
exports.NO_NONCE = 'NO_NOUNCE';
exports.NO_PROVIDER = 'NO_PROVIDER';
exports.NOT_AUTHORIZED = 'NOT_AUTHORIZED';
exports.LOGOUT_ERROR = 'LOGOUT_ERROR';
